// @ts-strict

import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UploadedImage } from '../img-upload-input.component';

@Component({
  selector: 'app-single-img',
  templateUrl: './single-img.component.html',
  styleUrls: ['./single-img.component.scss']
})
export class SingleImgComponent {
  @Input() imgFile?: UploadedImage;
  @Output() removeImg = new EventEmitter<UploadedImage>();

  public onRemove(): void {
    this.removeImg.emit(this.imgFile);
  }
}
